import gql from 'graphql-tag';

export const createDOPEntry = gql`
  mutation createDOPEntry($input: CreateDOPEntry) {
    createDOPEntry(input: $input) {
      id
      aorId
      aorSubSystemId
      labelId
      entry
      active
      shiftDate
      createdBy
      createdAt
      updater
      updatedAt
      deletedAt
      version
    }
  }
`;
